export const getCurrencyIcon = (currency) => {
  switch (currency) {
    case "YEN":
    case 4:
      return "¥";
    case "USD":
    case 2:
      return "$";
    case "CAD":
    case 3:
      return "$";
    case "NGN":
    case 8:
      return "₦";
    case "EURO":
    case 1:
      return "€";
    default:
      return "";
  }
};
